import { useTranslation } from 'react-i18next';

export default function TestimonialSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-50">
      <div className="w-full px-6 md:px-10 py-20 md:py-28">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12 items-center">
            <div className="lg:col-span-5">
              <div className="rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Confident%20young%20European%20woman%20with%20warm%20smile%20in%20casual%20chic%20beige%20outfit%20leaning%20against%20cream%20wall%2C%20soft%20natural%20window%20lighting%20from%20left%20side%2C%20editorial%20portrait%20photography%2C%20authentic%20genuine%20joyful%20expression%2C%20clean%20minimalist%20composition%2C%20golden%20hour%20warm%20tones%2C%20lifestyle%20fashion%20aesthetic&width=600&height=700&seq=testimonial-v3&orientation=portrait"
                  alt="Zadowolona użytkowniczka Kakobuy Spreadsheet"
                  className="w-full h-auto"
                />
              </div>
            </div>
            <div className="lg:col-span-7">
              <p className="text-xs font-medium text-foreground-500 uppercase tracking-wider mb-4">
                &ldquo; Opinie użytkowników &rdquo;
              </p>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-2">
                {t('testimonial.title')}
              </h2>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-300 mb-8">
                Kakobuy Spreadsheet
              </h2>

              <blockquote className="text-base md:text-lg text-foreground-700 leading-relaxed mb-6 pl-0">
                &ldquo;{t('testimonial.quote')}&rdquo;
              </blockquote>

              <p className="text-sm font-semibold text-foreground-900">
                &mdash; {t('testimonial.author')}
              </p>

              <div className="flex items-center gap-2 mt-8">
                <button className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-400 hover:border-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">
                  <i className="ri-arrow-left-line"></i>
                </button>
                <button className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 cursor-pointer">
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}